export default {
  title: '技术',
  subtitle: 'Titron Technology Stack',
  description: '基于先进的密码学技术和创新的共识机制，构建下一代隐私保护区块链基础设施',
  coreTech: {
    title: '核心技术',
    description: '基于最先进的密码学技术，实现真正的隐私保护',
    zkp: {
      title: '零知识证明 (ZKP)',
      subtitle: 'Zero-Knowledge Proofs',
      description: '在不泄露任何信息的情况下证明某个陈述的真实性，实现数据可验证而不可见',
      features: [
        'zk-SNARKs 和 zk-STARKs 支持',
        '隐私保护交易验证',
        '身份认证而不泄露身份',
        '可验证计算'
      ]
    },
    homomorphic: {
      title: '同态加密',
      subtitle: 'Homomorphic Encryption',
      description: '允许对加密数据直接进行计算，而无需先解密，保护数据隐私的同时支持计算',
      features: [
        '全同态加密 (FHE)',
        '部分同态加密 (PHE)',
        '安全多方计算',
        '隐私保护机器学习'
      ]
    },
    ringSignatures: {
      title: '环签名技术',
      subtitle: 'Ring Signatures',
      description: '提供交易发送方的匿名性，使得无法确定具体是哪个用户发起了交易',
      features: [
        '发送方匿名性',
        '不可链接性',
        '抗量子攻击',
        '高效签名验证'
      ]
    },
    mpc: {
      title: '去中心化身份',
      subtitle: 'Decentralized Identity',
      description: '基于区块链的身份管理系统，用户完全控制自己的身份信息和数据授权',
      features: [
        '自主身份管理',
        '选择性披露',
        '跨平台身份验证',
        '数据主权控制'
      ]
    }
  },
  consensus: {
    title: '共识机制',
    heading: '创新的共识算法',
    description: '结合隐私保护和高效验证的创新共识机制',
    bft: {
      title: '改进的拜占庭容错',
      subtitle: 'Enhanced BFT',
      description: '基于拜占庭容错共识算法，提供快速交易确认和高吞吐量',
      features: [
        '快速交易确认 (2-3秒)',
        '高吞吐量 (10,000+ TPS)',
        '强一致性保证',
        '抗恶意节点攻击'
      ]
    },
    pos: {
      title: '权益证明',
      subtitle: 'Proof of Stake',
      description: '基于持币量的共识机制，节能环保且安全可靠',
      features: [
        '节能环保',
        '经济激励对齐',
        '长期安全性',
        '去中心化治理'
      ]
    }
  },
  specs: {
    title: '技术规格',
    heading: '技术参数',
    description: 'Titron网络的技术规格和性能指标',
    network: {
      category: '网络性能',
      transactionTime: '交易确认时间',
      throughput: '吞吐量',
      blockTime: '区块时间',
      latency: '网络延迟',
      values: {
        transactionTime: '2-3秒',
        throughput: '10,000+ TPS',
        blockTime: '1秒',
        latency: '< 100ms'
      }
    },
    privacy: {
      category: '隐私保护',
      zkProof: '零知识证明',
      homomorphic: '同态加密',
      ringSignature: '环签名',
      privacyLevel: '隐私级别',
      values: {
        zkProof: 'zk-SNARKs/STARKs',
        homomorphic: '全同态加密',
        ringSignature: '支持',
        privacyLevel: '完全匿名'
      }
    },
    development: {
      category: '开发支持',
      smartContracts: '智能合约',
      programmingLanguages: '编程语言',
      devTools: '开发工具',
      testnet: '测试网络',
      values: {
        smartContracts: 'EVM + WASM',
        programmingLanguages: 'Solidity, Rust, Go',
        devTools: '完整SDK',
        testnet: '免费使用'
      }
    }
  },
  innovation: {
    title: '创新亮点',
    heading: '技术创新',
    description: 'Titron在隐私保护技术方面的创新突破',
    hybrid: {
      title: '混合隐私模型',
      description: '结合多种隐私技术，提供全方位的隐私保护'
    },
    scalable: {
      title: '可扩展架构',
      description: '模块化设计，支持水平扩展和功能升级'
    },
    crosschain: {
      title: '跨链兼容',
      description: '与主流区块链网络无缝集成和互操作'
    },
    developerFriendly: {
      title: '开发者友好',
      description: '丰富的开发工具和文档，降低开发门槛'
    }
  },
  cta: {
    title: '开始使用Titron技术',
    description: '探索我们的技术文档，开始构建隐私保护的应用程序',
    button: '开始构建',
    techDocs: '技术文档'
  }
};
